import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050505] border-t border-white/5 mt-auto"
    >
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-1.5 h-1.5 bg-[#D4AF37]" />
            <span className="font-display text-lg tracking-tight text-white">
              Wagenhofer <span className="text-zinc-400">Capital</span>
            </span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-sm mb-6">
            Beteiligungs- und Verwaltungsgesellschaft von{" "}
            <Link
              to="/ueber-uns#gruender"
              data-testid="footer-founder"
              className="text-zinc-200 hover:text-[#D4AF37] transition-colors"
            >
              Leo Wagenhofer
            </Link>
            {" "}aus dem Raum München – strategische Beteiligungen, Immobilien,
            Gastronomie und langfristiger Vermögensaufbau.
          </p>
          <address className="not-italic text-sm text-zinc-300 leading-relaxed">
            Wagenhofer Capital GmbH
            <br />
            Max-Löw-Straße 27
            <br />
            85579 Neubiberg · Deutschland
          </address>
          <a
            href="mailto:muenchen@wagenhofer.capital"
            data-testid="footer-email"
            className="inline-block mt-4 text-sm text-zinc-300 hover:text-[#D4AF37] break-all transition-colors"
          >
            muenchen@wagenhofer.capital
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Unternehmen</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/ueber-uns" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Über uns</Link></li>
            <li><Link to="/werte" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Werte</Link></li>
            <li><Link to="/presse" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Presse</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Investment</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/investmentfokus" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Investmentfokus</Link></li>
            <li><Link to="/ablauf" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Ablauf einer Beteiligung</Link></li>
            <li><Link to="/insights" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Insights</Link></li>
            <li><Link to="/faq" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">FAQ</Link></li>
            <li><Link to="/kontakt" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-5">Rechtliches</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/impressum" data-testid="footer-impressum" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Impressum</Link></li>
            <li><Link to="/datenschutz" data-testid="footer-datenschutz" className="text-zinc-300 hover:text-[#D4AF37] transition-colors">Datenschutz</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="container-x py-10">
          <p
            data-testid="footer-disclaimer"
            className="text-[11px] leading-relaxed text-zinc-500 max-w-4xl"
          >
            Wagenhofer Capital bietet keine Anlageberatung,
            Finanzportfolioverwaltung oder Finanzdienstleistungen gegenüber
            Dritten an. Diese Website dient ausschließlich der allgemeinen
            Unternehmensdarstellung und stellt kein öffentliches Angebot zum
            Erwerb von Beteiligungen oder Kapitalanlagen dar.
          </p>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="container-x py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-zinc-500">
          <span data-testid="copyright">
            © 2026 Wagenhofer Capital GmbH. Alle Rechte vorbehalten.
          </span>
          <span className="tracking-[0.24em] uppercase">München · Bayern · Deutschland</span>
        </div>
      </div>
    </footer>
  );
}
